import { handleError } from 'api/utils';
import { createRequest } from 'api/request';

export const getOrgFees = async (state) => {
  return createRequest(`/v1/fee_schedules`, state, {
    method: 'GET',
  }).then((res) => handleError(res));
};
